<template>
  <div style="margin: 20px">
    <el-form>
      <el-row type="flex" justify="left" style="flex-wrap: wrap;align-items: center">
        <el-col :span="8">
          <el-form-item :label="$t('newOrder.waybillStatus')">
            <el-select
              v-model="wForm.params.waybillStatus"
              :placeholder="$t('GlobalSetObj.all')"
              clearable collapse-tags filterable
              multiple size="small"
              style="width: 90%"
            >
              <el-option
                v-for="(item, ind) in waybillStatusList"
                :key="ind"
                :label="item.label"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <!--  处理状态   -->
          <el-form-item :label="$t('GlobalSetObj.ProcessingStatus')">
            <el-select
              v-model="wForm.params.processingState"
              :placeholder="$t('GlobalSetObj.all')"
              clearable size="small"
              style="width: 90%"
            >
              <el-option :label="$t('GlobalSetObj.Pending')" :value="1" /><!--待处理-->
              <el-option :label="$t('collectionCenter.processed')" :value="2" /><!--已处理-->
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <!--搜索-->
          <el-button
            size="small" type="primary" @click="waybillSearch"
          >{{ $t('newOrder.search') }}
          </el-button>
          <!--重置-->
          <el-button
            size="small" @click="waybillReset"
          >{{ $t('newOrder.reset') }}
          </el-button>
          <!--导出-->
          <el-button
            size="small" type="primary" @click="exportExcel"
          >{{ $t('newOrder.export') }}
          </el-button>
        </el-col>
      </el-row>
    </el-form>
    <el-table
      border
      max-height="600"
      :data="detailsTableData"
      style="width: 100%"
    >
      <el-table-column
        :label="$t('GlobalSetObj.serial')"
        align="center"
        type="index"
        width="70"
      />
      <el-table-column :label="$t('collectionCenter.waybillNumber')" prop="waybillNumber" align="center" />
      <el-table-column :label="$t('collectionCenter.ScanNumber')" prop="scanNumber" align="center" />
      <el-table-column :label="$t('GlobalSetObj.ProcessingStatus')" prop="processingStatus" align="center">
        <template slot-scope="scope">
          <div>
            <el-tag
              v-if="scope.row.processingStatus === 1" type="success"
            >{{ $t('GlobalSetObj.Pending') }}</el-tag>
            <el-tag
              v-else-if="scope.row.processingStatus === 2"
            >{{ $t('collectionCenter.processed') }}</el-tag>
            <span v-else>--</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('collectionCenter.processingResult')" prop="handlingResult" align="center">
        <template slot-scope="scope">
          <div>
            {{
              scope.row.handlingResult === 1 ? $t('collectionCenter.upstreamResponsibility')
                : scope.row.handlingResult === 2 ? $t('collectionCenter.downstreamResponsibility')
                  : scope.row.handlingResult === 3 ? $t('GlobalSetObj.blameless')
                    : scope.row.handlingResult === 4 ? $t('home.moreTimeNotReply')
                      : scope.row.handlingResult === 5 ? $t('collectionCenter.partialResponsibility') : '--'
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('collectionCenter.shipmentStatus')" prop="waybillStatusName" align="center" />
      <el-table-column :label="$t('orderCenterCont.zuixinguijineir')" prop="latestTrackContent" align="center" />
      <el-table-column :label="$t('fixDutyFine.LatestTrackingBranch')" prop="latestTrackSite" align="center" />
      <el-table-column :label="$t('collectionCenter.loadTime')" prop="loadedTime" align="center" />
      <el-table-column :label="$t('collectionCenter.loadSiteIdList')" prop="loadedSite" align="center" />
      <el-table-column :label="$t('collectionCenter.loader')" prop="loadUserName" align="center" />
      <el-table-column v-if="wayId.ticketStatus !== 4 && wayId.ticketType !== 1" :label="$t('newOrder.operation')" align="center" fixed="right">
        <template slot-scope="scope">
          <div v-if="scope.row.processingStatus !== 2" @click="openProcess(scope.row)" style="color: #2494ff; cursor: pointer">{{ $t('seller.process') }}</div><!--  处理  -->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="wForm.pageNumber"
      :page-size="wForm.pageSize"
      :page-sizes="[10, 50, 100, 500, 1000]"
      :total="detailsTotal"
      background
      layout="total, sizes, prev, pager, next, jumper"
      style="margin: 10px 0; float: right"
      @size-change="waybillSearch"
      @current-change="waybillSearch1"
    />

    <!--处理结果-->
    <el-dialog
      :title="$t('collectionCenter.processingResult')"
      :visible.sync="pRDialogVisible"
      width="30%"
      :before-close="processRClose"
      append-to-body
    >
      <div style="font-size: 15px; font-weight: bold; color: #67696d">
        {{ $t('GlobalSetObj.totalOptions') }}：1
      </div>
      <el-form ref="pRFormRef" :model="pRForm" label-position="top" style="margin: 10px">
        <el-row>
          <el-col :span="24">
            <!-- 处理结果 -->
            <el-form-item
              :label="$t('collectionCenter.processingResult') + '：'" prop="handlingResult"
              :rules="[{ required: true, message: $t('GlobalSetObj.pleaseChoose'), trigger: 'change' }]"
            >
              <el-select
                v-model="pRForm.handlingResult"
                :placeholder="$t('collectionCenter.pleaseChoose')" clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in processResultList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="processRClose">{{ $t('GlobalSetObj.cancel') }}</el-button>
        <el-button type="primary" @click="submitProcess">{{ $t('GlobalSetObj.confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { waybillStatusList } from '@/utils/enumData';
import {
  handoverAbnormalityDetails,
  handoverAbnormalityDetailsExport,
  handoverAbnormalityDetailsDispose
} from '@/api/newExpressAPI';
import { goResourceTaskList } from '@/utils/goExportList';
export default {
  props: {
    wayId: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      wForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          waybillStatus: [],
          processingState: '',
          id: null
        }
      },
      waybillStatusList: waybillStatusList,
      detailsTableData: [],
      detailsTotal: 0,
      pRDialogVisible: false,
      processResultList: [
        { id: 1, name: this.$t('collectionCenter.upstreamResponsibility') }, // 上游责任
        { id: 2, name: this.$t('collectionCenter.downstreamResponsibility') }, // 下游责任
        { id: 3, name: this.$t('GlobalSetObj.blameless') } // 无责
      ],
      pRForm: {
        id: null,
        handlingResult: null
      }
    };
  },
  methods: {
    waybillSearch() {
      this.wForm.params.id = this.wayId.id;
      this.wForm.pageNumber = 1;
      this.waybillSearch1();
    },
    waybillSearch1() {
      handoverAbnormalityDetails(this.wForm).then(res => {
        if (res.code === 200) {
          this.detailsTotal = res.data.total;
          this.detailsTableData = res.data.records;
        }
      });
    },
    waybillReset() {
      this.wForm.params.waybillStatus = [];
      this.wForm.params.processingState = '';
      this.waybillSearch();
    },
    exportExcel() {
      handoverAbnormalityDetailsExport(this.wForm.params).then(res => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    },
    openProcess(row) {
      this.pRForm = {
        id: row.id,
        handlingResult: null
      };
      this.pRDialogVisible = true;
    },
    processRClose() {
      this.pRForm.id = null;
      this.pRForm.handlingResult = null;
      this.pRDialogVisible = false;
      this.$refs.pRFormRef.clearValidate();
    },
    submitProcess() {
      this.$refs.pRFormRef.validate((valid) => {
        if (valid) {
          handoverAbnormalityDetailsDispose(this.pRForm).then(res => {
            if (res.code === 200) {
              this.$message.success(this.$t('basicData.TheOperationSucceeded'));
              this.processRClose();
              this.waybillSearch();
            }
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
